<template>

  <div class="flex gap-2 items-center">
    <input

        @change="emit('update')"

        @input="emit('update')"
        v-if="field.type !== 'section'" class="input input-bordered flex-1"
        placeholder="label" v-model="field.label"/>
    <input

        @change="emit('update')"
        @input="emit('update')"
        v-if="field.type !== 'section'" class="input input-bordered" placeholder="key"
        v-model="field.key"/>

    <input

        @change="emit('update')"
        @input="emit('update')"
        v-if="field.type === 'section'" class="input input-bordered w-full" placeholder="Section title"
        v-model="field.title"/>

    <select class="select select-bordered"
            @change="emit('update')"
            @input="emit('update')"
            v-model="field.type">
      <option value="text">text</option>
      <option value="textarea">textarea</option>
      <option value="number">number</option>
      <option value="boolean">boolean</option>
      <option value="select">select</option>
      <option value="multiselect">multiselect</option>
      <option value="date">date</option>
      <option value="time">time</option>
      <option value="datetime">datetime</option>
      <option value="photo">photo</option>
      <option value="file">file</option>
      <option value="signature">signature</option>
      <option value="rating">rating</option>
      <option value="section">section</option>
    </select>
    <span class="mx-2">Required</span>
    <input type="checkbox"
           @change="emit('update')"
           @click="emit('update')"
           v-model="field.required"/>
    <button type="button" class="btn btn-error btn-sm" @click="emit('remove', props.index)">Remove</button>
  </div>
  <div
      @change="emit('update')"
      v-if="field.type === 'select' || field.type === 'multiselect'">
    <label class="label">Options (comma-separated)</label>
    <input class="input input-bordered w-full"
           :value="field.values.join(',')"
           @input="event => field.values = event.target.value.split(',')"/>
  </div>
  <div
      @change="emit('update')"
      v-if="field.type === 'boolean'">
    <label class="label">Default value</label>
    <input type="checkbox" v-model="field.options.default"/>
    <!--       @change="f.values = (f._optionsText || '').split(',').map(o => o.trim()).filter(Boolean)" -->
  </div>

  <div v-if="field.type === 'section'">
    <div class="mt-2">
      <button type="button" class="btn btn-xs" @click="addChild()">Add Child Field</button>
    </div>

    <div v-for="(c, cidx) in (field.children || [])" :key="cidx" class="mt-2 border rounded p-2">
      <TemplateField :field="c" :index="cidx"></TemplateField>
    </div>
  </div>
</template>
<script setup lang="ts">
import {defineProps, PropType} from "vue";
import {buildField} from "./FieldHelper";

export interface FiledType {
  title?: string,
  label: string,
  type: string,
  key: string,
  required: boolean
  order?: number,
  default?: any,
  options?: {
    [key: string]: any;
  },
  children?: Array<FiledType>,
  values?: string[] | string,
};
let emit = defineEmits(['remove', 'update']);
const props = defineProps({
  field: {
    required: true,
    type: Object as PropType<FiledType>,
  },
  index: Number
});
let {field, index} = props;

// normalize field options property
if (!field.options) field.options = {};
if (Array.isArray(field.options)) {
  field.values = field.options.join(',');
  field.options = {}
}

// normalize field values property
if (field.values && !Array.isArray(field.values)) {
  field.values = field.values.split(',');
}

function addChild() {
  field.children ||= []
  field.children.push(buildField())
  emit("update", field)
}
</script>